export const PHONE_DISPLAY = "07836 207134";
export const PHONE_TEL = "tel:07836207134";
export const WHATSAPP_URL = "https://wa.me/447836207134";
export const EMAIL = "easyhandymanservicesuk@gmail.com";
export const EMAIL_HREF = `mailto:${EMAIL}`;
export const TAGLINE = "Your Home, Our Priority.";
export const HOURS = [
  { day: "Monday – Saturday", time: "8:00 AM – 6:00 PM" },
  { day: "Sunday", time: "Closed" },
];
export const SAMPLE_LABEL = "Sample image – to be replaced with real project photo";

export const NAV = [
  { name: "Home", path: "/", id: "home" },
  { name: "Services", path: "/services", id: "services" },
  { name: "Why Us", path: "/why-choose-us", id: "why-us" },
  { name: "Gallery", path: "/gallery", id: "gallery" },
  { name: "Reviews", path: "/reviews", id: "reviews" },
  { name: "Contact", path: "/contact", id: "contact" },
];

export const SERVICES = [
  {
    slug: "interior",
    number: "01",
    title: "Interior Home Improvements",
    short: "Painting, decorating, insulation and the small jobs that make a big difference indoors.",
    description:
      "Give your home a fresh new look with our interior improvement and maintenance services. Whether you're refreshing a room, improving your walls or carrying out small renovation projects, we're here to help.",
    items: [
      "Interior wall painting and decorating",
      "Skirting board painting",
      "Interior door painting",
      "Wallpaper removal",
      "Roof and wall insulation",
      "Interior wall demolition",
      "Silicone application and replacement",
      "General handyman and interior maintenance",
    ],
    image: "/images/interior-roller.webp",
    alt: "Paint roller applying fresh paint to an interior wall – interior painting in Oxfordshire",
    formValue: "Interior Home Improvements",
  },
  {
    slug: "garden",
    number: "02",
    title: "Garden Maintenance",
    longTitle: "Garden Maintenance & Outdoor Services",
    short: "Lawns, fences, driveways and garages – outdoor spaces kept neat, clean and welcoming.",
    description:
      "Keep your outdoor spaces looking their best. From lawn maintenance and fence painting to driveway cleaning and garden tidying, we help create clean, attractive and welcoming outdoor spaces.",
    items: [
      "Lawn installation and grass seeding",
      "Grass cutting and lawn maintenance",
      "Fence painting",
      "Garden tidying and maintenance",
      "Cleaning up levelled ground and tidying soil",
      "Garage organisation and cleaning",
      "Driveway pressure washing",
    ],
    image: "/images/garden-lawn.webp",
    alt: "Freshly striped green lawn bordered by trees – garden maintenance in Oxfordshire",
    formValue: "Garden Maintenance & Outdoor Services",
  },
  {
    slug: "cleaning",
    number: "03",
    title: "Professional House Cleaning",
    short: "Regular, detailed and deep cleans, plus carpet washing – done with care.",
    description:
      "Enjoy a cleaner, fresher home with our domestic cleaning services. Whether you need regular cleaning or a thorough deep clean, we provide careful attention to detail.",
    items: [
      "Regular domestic cleaning",
      "Detailed house cleaning",
      "Deep cleaning",
      "Carpet washing and cleaning",
    ],
    image: "/images/cleaning-gloves.webp",
    alt: "Gloved hand dusting a kitchen stool during a deep clean – house cleaning in Oxfordshire",
    formValue: "Professional House Cleaning",
  },
];

export const WHY = [
  { title: "5 years of experience", text: "Five years looking after homes and gardens, so we know how to get the job done properly." },
  { title: "Friendly and reliable service", text: "We turn up when we say we will, keep you informed and treat your home with respect." },
  { title: "Free quotations", text: "Tell us what you need and we'll give you a clear, no-obligation quote – free of charge." },
  { title: "Attention to detail", text: "Neat edges, clean finishes and a tidy space when we leave. The small things matter." },
  { title: "Multiple services under one roof", text: "Painting, gardening and cleaning from one team – one call instead of three." },
  { title: "Serving all of Oxfordshire", text: "Wherever you are in Oxfordshire, get in touch and we'll arrange a visit." },
];

export const MARQUEE = [
  "Interior painting", "Wallpaper removal", "Insulation", "Silicone replacement", "Lawn installation",
  "Grass cutting", "Fence painting", "Driveway pressure washing", "Deep cleaning", "Carpet cleaning",
];

export const GALLERY = [
  { id: "int-ba", category: "interior", type: "ba", real: true, title: "Kitchen wall repair and repaint – before & after",
    before: "/images/real-kitchen-before.webp", after: "/images/real-kitchen-after.webp",
    beforeAlt: "Kitchen wall with patched, damaged plaster before repair and painting", afterAlt: "Same kitchen wall smooth and freshly painted white after interior decorating in Oxfordshire" },
  { id: "int-1", category: "interior", type: "single", real: true, title: "Roof insulation between rafters",
    src: "/images/real-roof-insulation.webp", alt: "Foil-backed insulation boards fitted between timber roof rafters – roof insulation in Oxfordshire" },
  { id: "int-2", category: "interior", type: "single", real: true, title: "Ceiling and roof insulation",
    src: "/images/real-ceiling-insulation.webp", alt: "Insulation boards fitted and taped across a sloping ceiling, with scaffold tower below" },
  { id: "int-3", category: "interior", type: "single", real: true, title: "Dormer and loft insulation",
    src: "/images/real-dormer-insulation.webp", alt: "Loft dormer walls and roof lined with insulation boards around a new window" },
  { id: "int-ba2", category: "interior", type: "ba", real: true, title: "Living room crack repair and repaint – before & after",
    before: "/images/real-living-before.webp", after: "/images/real-living-after.webp",
    beforeAlt: "Living room walls with visible cracks near the ceiling before repair", afterAlt: "Same living room with cracks filled and walls freshly painted – interior painting in Oxfordshire" },
  { id: "int-4", category: "interior", type: "single", real: true, title: "Window sill painting and sealing",
    src: "/images/real-window-sill-front.webp", alt: "Freshly painted white window sill above a radiator" },
  { id: "int-5", category: "interior", type: "single", real: true, title: "Window sill finish – side view",
    src: "/images/real-window-sill-angle.webp", alt: "Glossy painted window sill and reveal viewed from the side" },
  { id: "int-6", category: "interior", type: "single", real: true, title: "Window reveal and sill refresh",
    src: "/images/real-window-sill-side.webp", alt: "Painted window reveal and sill with silicone gun ready for sealing" },
  { id: "gar-ba", category: "garden", type: "ba", title: "Garden tidy – before & after layout",
    before: "/images/garden-before.webp", after: "/images/garden-lawn.webp",
    beforeAlt: "Sample: overgrown garden before tidying", afterAlt: "Sample: neatly cut striped lawn after maintenance" },
  { id: "gar-1", category: "garden", type: "single", title: "Grass cutting",
    src: "/images/garden-mower.webp", alt: "Sample: lawn mower on freshly cut grass" },
  { id: "gar-2", category: "garden", type: "single", title: "Driveway pressure washing",
    src: "/images/driveway.webp", alt: "Sample: clean concrete driveway in front of a garage" },
  { id: "cln-ba", category: "cleaning", type: "ba", title: "Carpet & room clean – before & after layout",
    before: "/images/carpet-before.webp", after: "/images/clean-after.webp",
    beforeAlt: "Sample: messy carpet before cleaning", afterAlt: "Sample: spotless living room after a deep clean" },
  { id: "cln-1", category: "cleaning", type: "single", title: "Detailed house cleaning",
    src: "/images/cleaning-gloves.webp", alt: "Sample: dusting a kitchen during a detailed clean" },
  { id: "cln-2", category: "cleaning", type: "single", title: "Regular domestic cleaning",
    src: "/images/cleaning-stairs.webp", alt: "Sample: cleaner carrying supplies up a staircase" },
];

export const GALLERY_GROUPS = [
  { id: "interior", label: "Interior Improvements" },
  { id: "garden", label: "Garden Maintenance" },
  { id: "cleaning", label: "House Cleaning" },
];

export const GALLERY_TABS = [
  { id: "all", label: "All" },
  { id: "interior", label: "Interior Improvements" },
  { id: "garden", label: "Garden Maintenance" },
  { id: "cleaning", label: "House Cleaning" },
];
